import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import { CalendarEvents, Events } from '@busy-human/k9-library';
import { DataInstance } from "@busy-human/gearbox";
import { useCalendars } from "@/store/useCalendars";
import Calendar from '@/components/linear-calendar.vue';
import EventModal from '@/components/event-modal.vue';
import Modal from '@/components/Modal.vue';
import PendingRequests from "@/components/pending-requests.vue";
import ManageCalendarsModal from "@/components/scheduling/manage-calendars-modal.vue";
import Alert from "@/components/alerts.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'scheduling',
  setup(__props, { expose: __expose }) {
  __expose();

const calendarStore = useCalendars();
const selectedEvent = ref<DataInstance<CalendarEvents.Model> | null>(null);

const userEvents = computed(() => {
	const tmp: DataInstance<Events.Model>[] = [];
	for(const [, cal] of calendarStore.events) {
		for(const evs of Object.values(cal)) {
			tmp.push(...evs);
		}
	}
	return tmp;
});

const showAlert = computed(()=>{

    if( !calendarStore.loading && calendarStore.main?.calendarId === undefined){
        return true;
    } else {
        return false;
    }

});
// })

const display = ref<'month' | 'week' | 'day'>('week');
const sort = ref<'trainer' | 'kennel' | 'time'>('trainer');
const selectedDate = ref<Date>(new Date());

// Calendar Management

const showCalendarModal = ref(false);
const selectedCalendar = ref<string | null>(null);
const userSelectedCalendar = ref<boolean>(false);

watch(selectedCalendar, (cal) => {
	if(cal) {
		userSelectedCalendar.value = true;
	}
});

function openManageCalendarModal() {
	showCalendarModal.value = true;
}

const __returned__ = { calendarStore, selectedEvent, userEvents, showAlert, display, sort, selectedDate, showCalendarModal, selectedCalendar, userSelectedCalendar, openManageCalendarModal, ref, computed, watch, get CalendarEvents() { return CalendarEvents }, get Events() { return Events }, get DataInstance() { return DataInstance }, get useCalendars() { return useCalendars }, Calendar, EventModal, Modal, PendingRequests, ManageCalendarsModal, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})